import apiService from '../Api'

export interface IList {
  current_page: number
  per_page: number
  total: number
  data: {
    id: number
    name: string
    email: string
    picture: string
    pending_approval: boolean
    roles: string[]
  }[]
}

export interface ICreateUser {
  name: string
  email: string
  password: string
  password_confirmation: string
  picture: File
  roles: number[]
}

export interface IUpdateUser {
  name: string
  email: string
  password?: string
  password_confirmation?: string
  picture?: File | string
  roles: number[]
}

export class UserService {
  async list(filter: { page?: number; pageSize?: number }): Promise<IList> {
    return apiService
      .get('/user', {
        params: {
          page: filter.page ?? 1,
          page_size: filter.pageSize ?? 10
        }
      })
      .then((response) => response.data)
  }

  async create(data: ICreateUser): Promise<any> {
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('email', data.email)
    formData.append('password', data.password)
    formData.append('password_confirmation', data.password_confirmation)
    formData.append('picture', data.picture)
    for (const role of data.roles) {
      formData.append('roles[]', role.toString())
    }

    return apiService.post('/user', formData).then((response) => response.data)
  }

  async update(userId: number, data: IUpdateUser, updatePassword: boolean): Promise<any> {
    const formData = new FormData()
    formData.append('_method', 'PUT')
    formData.append('name', data.name)
    formData.append('email', data.email)
    if (updatePassword && data.password && data.password_confirmation) {
      formData.append('password', data.password)
      formData.append('password_confirmation', data.password_confirmation)
    }
    if (data.picture instanceof File) {
      formData.append('picture', data.picture)
    }
    for (const role of data.roles) {
      formData.append('roles[]', role.toString())
    }

    return apiService
      .post(`/user/${userId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => response.data)
  }

  async listRoles(): Promise<{ id: number; name: string }[]> {
    return apiService.get('/user/roles').then((response) => response.data)
  }

  async updateRoles(id: number, roles: number[]) {
    return apiService.put(`/user/${id}/roles`, { roles }).then((response) => response.data)
  }

  async restrict(id: number) {
    return apiService.post(`/user/restrict/${id}`).then((response) => response.data)
  }

  async unrestrict(id: number) {
    return apiService.post(`/user/unrestrict/${id}`).then((response) => response.data)
  }

  async destroy(id: number) {
    return apiService.delete(`/user/${id}`).then((response) => response.data)
  }
}
